/**
 * Predicate for filtering wishlist v2 list items down to the set that should
 * be rendered (and tracked in analytics) for the user.
 *
 * The wishlists v2 list endpoint annotates each item with an `errors` array
 * when the underlying product can no longer be purchased for the user's
 * marketplace. Observed codes include:
 *   - `PRODUCT_NOT_BUYABLE`     (e.g. product status = INACTIVE)
 *   - `PRODUCT_NOT_SUPPORTED`   (e.g. product not sold in this marketplace)
 *
 * Items in this state are filtered out at the data layer so:
 *   - Favorites and the cart-side inline favorites list don't render an
 *     "unavailable" placeholder card for a product the user can never act on.
 *   - Analytics (`getWishlistAnalyticsData`) only reports what the user sees.
 *   - The Item Added modal's "first list item" lookup never lands on an
 *     unactionable entry.
 *
 * Pre-launch / not-yet-active products do not surface through `errors` —
 * they come back successfully and may render an "upcoming" badge in a
 * future enhancement (see `specs/hydration-spec.md#inactive-product-handling`).
 *
 * @param {{errors?: Array}} item - Wishlist v2 list item.
 * @returns {boolean} True when the item is purchasable and should be rendered.
 */
var isWishlistItemActive = function isWishlistItemActive(item) {
  var _item$errors;
  return !((item === null || item === void 0 || (_item$errors = item.errors) === null || _item$errors === void 0 ? void 0 : _item$errors.length) > 0);
};
export default isWishlistItemActive;